import {combineReducers} from 'redux';

import {default as listReducer} from './list';
import {default as detailReducer} from './detail';

const reducer = combineReducers({
  list: listReducer,
  detail: detailReducer
});

export default reducer;
export * from './list';
export * from './detail';
